import axios, { AxiosInstance, AxiosError } from 'axios';
import { API_BASE_URL, CONFIG } from './api';
import { parseAxiosError, logError } from '../utils/errorUtils';

// Create axios instance with default configuration
export const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: CONFIG.apiTimeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token
apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (CONFIG.enableLogging) {
      console.log(`🚀 API Request: ${config.method?.toUpperCase()} ${config.url}`);
    }

    return config;
  },
  error => {
    if (CONFIG.enableLogging) {
      console.error('❌ Request Error:', error);
    }
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
apiClient.interceptors.response.use(
  response => {
    if (CONFIG.enableLogging) {
      console.log(`✅ API Response: ${response.status} ${response.config.url}`);
    }
    return response;
  },
  (error: AxiosError) => {
    // Parse error using our centralized error handling
    const appError = parseAxiosError(error);

    if (CONFIG.enableLogging) {
      logError(
        appError,
        `API Request: ${error.config?.method?.toUpperCase()} ${error.config?.url}`
      );
    }

    // Handle specific error cases
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      localStorage.removeItem('access_token');
      localStorage.removeItem('userInfo');
      window.location.href = '/login';
    }

    // Return the original axios error (services will handle parsing)
    return Promise.reject(error);
  }
);

export default apiClient;
